"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var lodash_1 = require("lodash");
var Table_1 = __importDefault(require("../Table"));
var helpers_1 = require("./helpers");
var Pagination_1 = require("../../Pagination");
var Checkbox_1 = require("../../Checkbox");
var types_1 = require("../../../types");
var Select_1 = require("../../Select");
var BasicSearch_1 = __importDefault(require("./BasicSearch"));
var placement_1 = require("../../../types/placement");
var Combobox_1 = __importDefault(require("../../ComboBox/Combobox"));
var assert_1 = require("../../../utils/assert");
var Button_1 = require("../../Button");
var Panel_1 = require("../../Panel");
var export_1 = require("../../../utils/export");
var filterContext_1 = __importDefault(require("../../../context/filterContext"));
// eslint-disable-next-line import/no-named-default
var DateFilter_1 = __importDefault(require("./DateFilter"));
var propTypes = {
    bulkActions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onSelected: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
    })),
    columns: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        isSortable: PropTypes.bool,
        align: PropTypes.string,
        mods: PropTypes.string,
    })).isRequired,
    customSearchFilter: PropTypes.any,
    defaultItemsPerPage: PropTypes.number,
    defaultPage: PropTypes.number,
    filters: PropTypes.arrayOf(PropTypes.func),
    hideRowsSelect: PropTypes.bool,
    includeBasicSearch: PropTypes.bool,
    loadData: PropTypes.func.isRequired,
    /**
     * @param {any} reloadDependency - The Table is reloaded every time this value changes
     */
    reloadDependency: PropTypes.any,
    mapDataToRow: PropTypes.func.isRequired,
    paginationPlacement: PropTypes.oneOf([placement_1.Placement.Top, placement_1.Placement.Bottom, placement_1.Placement.RightBottom]),
    rowsAreSelectable: PropTypes.bool,
    isLoading: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    defaultSort: PropTypes.string,
    noResultsText: PropTypes.string,
    rowSelected: PropTypes.func,
    shouldClearSelectedRows: PropTypes.bool,
    onExport: PropTypes.func,
    useExternalFilterProvider: PropTypes.bool,
    fullRowSelect: PropTypes.bool
};
var SelectFilter = function (fieldName, label, options, tooltip, tooltipLink) {
    return function (_a) {
        var isLast = _a.isLast;
        var ctx = React.useContext(filterContext_1.default);
        var onChange = function (values) {
            var _a;
            if ((values === null || values === void 0 ? void 0 : values.length) > 0 || (values === null || values === void 0 ? void 0 : values.kind)) {
                ctx.setActiveFilters(__assign(__assign({}, ctx.activeFilters), (_a = {}, _a[fieldName] = values, _a)));
            }
            else {
                delete ctx.activeFilters[fieldName];
                ctx.setActiveFilters(__assign({}, ctx.activeFilters));
            }
        };
        return (React.createElement(Combobox_1.default, { mods: isLast ? '' : 'u-spaceRightSm', onChange: onChange, selected: ctx.activeFilters[fieldName], name: fieldName, buttonLabel: label, tooltip: tooltip, tooltipLink: tooltipLink, items: options.length
                ? options
                : (0, helpers_1.convertObjsToValueLabel)(options) }));
    };
};
var DateFilter = function (fieldName, label, noDateLabel, yearPlaceholder, rangeMin, rangeMax) {
    return function (_a) {
        var isLast = _a.isLast;
        var ctx = React.useContext(filterContext_1.default);
        var onChange = function (values) {
            var _a;
            if ((values === null || values === void 0 ? void 0 : values.length) > 0 || (values === null || values === void 0 ? void 0 : values.kind)) {
                ctx.setActiveFilters(__assign(__assign({}, ctx.activeFilters), (_a = {}, _a[fieldName] = values, _a)));
            }
            else {
                delete ctx.activeFilters[fieldName];
                ctx.setActiveFilters(__assign({}, ctx.activeFilters));
            }
        };
        return (React.createElement(DateFilter_1.default, { mods: isLast ? '' : 'u-spaceRightSm', onChange: onChange, name: fieldName, title: label, noDateLabel: noDateLabel, yearPlaceholder: yearPlaceholder, rangeMin: rangeMin, rangeMax: rangeMax }));
    };
};
var PaginatedTable = function (_a) {
    var loadData = _a.loadData, reloadDependency = _a.reloadDependency, columns = _a.columns, mapDataToRow = _a.mapDataToRow, defaultPage = _a.defaultPage, defaultItemsPerPage = _a.defaultItemsPerPage, hideRowsSelect = _a.hideRowsSelect, _b = _a.rowsAreSelectable, rowsAreSelectable = _b === void 0 ? false : _b, bulkActions = _a.bulkActions, _c = _a.filters, filters = _c === void 0 ? [] : _c, customSearchFilter = _a.customSearchFilter, includeBasicSearch = _a.includeBasicSearch, searchPlaceholder = _a.searchPlaceholder, paginationPlacement = _a.paginationPlacement, defaultSort = _a.defaultSort, noResultsText = _a.noResultsText, rowSelected = _a.rowSelected, shouldClearSelectedRows = _a.shouldClearSelectedRows, _d = _a.onExport, onExport = _d === void 0 ? null : _d, isLoading = _a.isLoading, useExternalFilterProvider = _a.useExternalFilterProvider, _e = _a.fullRowSelect, fullRowSelect = _e === void 0 ? false : _e;
    (0, assert_1.assert)(!(filters.length && paginationPlacement === placement_1.Placement.Top), 'Invalid State: Pagination Positioning Top + Filters');
    var _f = (0, helpers_1.usePagination)(defaultItemsPerPage || 10, defaultPage || 1), _g = _f[0], itemsPerPage = _g[0], setItemsPerPage = _g[1], _h = _f[1], currentPage = _h[0], setCurrentPage = _h[1];
    var _j = React.useState(0), totalItems = _j[0], setTotalItems = _j[1];
    var _k = React.useState([]), dataSet = _k[0], setDataSet = _k[1];
    var _l = React.useState(''), sortName = _l[0], setSortName = _l[1];
    var _m = React.useState(false), sortAscending = _m[0], setSortAscending = _m[1];
    var _o = React.useState(false), isFetchingData = _o[0], setIsFetchingData = _o[1];
    var _p = React.useState([]), selected = _p[0], setSelected = _p[1];
    var _q = React.useState(''), searchTerm = _q[0], setSearchTerm = _q[1];
    var _r = React.useState(false), filterOpen = _r[0], setFilterOpen = _r[1];
    var _s = React.useState(false), isResettingFilters = _s[0], setIsResettingFilters = _s[1];
    var shouldDisplayPaginationAtBottom = paginationPlacement === placement_1.Placement.Bottom || paginationPlacement === placement_1.Placement.RightBottom;
    var shouldPaginateAtTop = !shouldDisplayPaginationAtBottom && filters.length === 0;
    var defaultPageSizeOptions = [10, 25, 50];
    var customOptions = defaultPageSizeOptions.indexOf(defaultItemsPerPage) < 0 ? [defaultItemsPerPage] : [];
    var pageSizeOptions = defaultPageSizeOptions.concat(customOptions).sort(function (a, b) {
        return a - b;
    });
    var filterContext = React.useContext(filterContext_1.default);
    var localFilters = React.useState({});
    var _t = useExternalFilterProvider
        ? filterContext
        : {
            activeFilters: localFilters[0],
            setActiveFilters: localFilters[1]
        }, activeFilters = _t.activeFilters, setActiveFilters = _t.setActiveFilters;
    React.useEffect(function () {
        if (shouldClearSelectedRows)
            setSelected([]);
    }, [shouldClearSelectedRows]);
    var setNewItemsPerPage = function (newItemsPerPage) {
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1);
    };
    var rows = dataSet.map(mapDataToRow);
    var cols = columns;
    var checkboxState = (0, helpers_1.getCheckboxStateForBulkActions)(selected, rows);
    if (rowsAreSelectable) {
        cols = __spreadArray([
            {
                name: 'selected',
                label: (React.createElement("div", null,
                    React.createElement(Checkbox_1.Checkbox, { name: "select-all", mods: "u-padBottomNone", inputProps: {
                            checked: checkboxState,
                            onChange: function () {
                                // if there is at least one row checked, clear all
                                if (checkboxState !== types_1.CheckboxStates.FALSE) {
                                    setSelected([]);
                                }
                                else {
                                    // select all rows if none are checked
                                    setSelected(rows);
                                }
                            },
                        } }))),
                mods: 'u-size1of12',
            }
        ], cols, true);
        // use IDs as keys to determine uniqueness
        var selectedids_1 = selected.map(function (e) { return e.id; });
        rows = rows.map(function (ele) {
            var rowData = __assign(__assign({}, ele), { selected: (React.createElement("div", null,
                    React.createElement(Checkbox_1.Checkbox, { name: "select-" + ele.id, mods: "u-padBottomNone", inputProps: {
                            checked: selectedids_1.includes(ele.id),
                            onChange: function () { },
                            onClick: function () {
                                if (selectedids_1.includes(ele.id)) {
                                    setSelected(selected.filter(function (e) { return e.id !== ele.id; }));
                                }
                                else {
                                    setSelected(__spreadArray(__spreadArray([], selected, true), [ele], false));
                                }
                            },
                        } }))) });
            if (rowData.selected && fullRowSelect) {
                rowData.onClick = function () {
                    if (selectedids_1.includes(ele.id)) {
                        setSelected(selected.filter(function (e) { return e.id !== ele.id; }));
                    }
                    else {
                        setSelected(__spreadArray(__spreadArray([], selected, true), [ele], false));
                    }
                };
            }
            return rowData;
        });
    }
    // collisions overwrite
    var bulkActionFuncsByLabel = bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.reduce(function (acc, action) {
        acc[action.label] = action.onSelected;
        return acc;
    }, {});
    var filterLength = Object.entries(activeFilters).length;
    var defaultSortStr = sortName.length ? "" + (sortAscending ? '-' : '') + sortName : defaultSort;
    var updateSearchFilter = function (_a) {
        var search = _a.searchTerm;
        setCurrentPage(1);
        setSearchTerm(search);
    };
    // Load new data when the metadata around pagination changes
    React.useEffect(function () {
        setIsFetchingData(true);
        if (!(0, lodash_1.isEmpty)(activeFilters)) {
            setFilterOpen(true);
        }
        loadData({
            page: currentPage,
            itemsPerPage: itemsPerPage,
            sortBy: sortName,
            sortAsc: sortAscending,
            filter: includeBasicSearch || activeFilters ? __assign({ searchTerm: searchTerm }, activeFilters) : null,
        }).then(function (_a) {
            var data = _a.data, currentTotalItems = _a.totalItems;
            setIsFetchingData(false);
            if (data)
                setDataSet(data);
            if (typeof currentTotalItems === 'number')
                setTotalItems(currentTotalItems);
        });
    }, [
        itemsPerPage,
        currentPage,
        sortName,
        sortAscending,
        searchTerm,
        activeFilters,
        reloadDependency,
    ]);
    React.useEffect(function () {
        setCurrentPage(1);
    }, [activeFilters]);
    React.useEffect(function () {
        if (isResettingFilters)
            setIsResettingFilters(false);
    }, [isResettingFilters]);
    React.useEffect(function () {
        if (rowSelected) {
            rowSelected(selected);
        }
    }, [selected]);
    var paginationItems = (React.createElement("div", { className: "Grid-cell u-flex u-flexJustifyEnd " + (!shouldPaginateAtTop ? 'u-sizeFill u-sizeFull' : 'u-sizeFit') },
        React.createElement("div", { className: "u-spaceAuto u-spaceRightSm" },
            React.createElement(Pagination_1.PaginationCurrentSubsetDisplay, { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems })),
        React.createElement(Pagination_1.PaginationButtons, { totalItems: totalItems, itemsPerPage: itemsPerPage, currentPage: currentPage, setCurrentPage: setCurrentPage, mods: paginationPlacement === placement_1.Placement.Bottom ? 'u-flexJustifyCenter u-flexGrow1' : '' }),
        !hideRowsSelect ? (React.createElement("div", { className: "u-spaceLeftSm" },
            React.createElement(Pagination_1.PaginationSelect, { options: pageSizeOptions, setItemsPerPage: setNewItemsPerPage, itemsPerPage: itemsPerPage }))) : null));
    var filtersSection = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "u-size7of8" }, filters.map(function (Item, index) { return (React.createElement(Item, { key: index, isLast: index === filters.length - 1 })); })),
        React.createElement("div", { className: "u-size1of8 u-textRight u-spaceRightMd" },
            React.createElement(Button_1.Button, { type: "text", onClick: function () {
                    setActiveFilters({});
                    // This is a bit weird.
                    // We were seeing issues updating the components successfully when clearing out all the filter
                    // values. This, paired with the condition in the filter rendering, forces the filter section
                    // to rerender when we clear out all the filters, ensuring that its rendering with the "freshest"
                    // of values from the context.
                    setIsResettingFilters(true);
                } }, "Clear All"))));
    var render = function () { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "Grid Grid-cell u-spaceTopSm" },
            (bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.length) > 0 ? (React.createElement("div", { className: "Grid-cell u-spaceRightSm u-flex u-size1of1 u-md-size2of12 u-flexJustifyStart" },
                React.createElement(Select_1.Select, { inputProps: {
                        value: '',
                        onChange: function (event) {
                            var fn = bulkActionFuncsByLabel[event.target.value];
                            if (fn) {
                                fn(selected);
                            }
                        },
                    }, name: "bulkActions", options: __spreadArray([
                        {
                            label: selected.length > 0 ? selected.length + " selected" : 'Actions',
                            value: null,
                        }
                    ], bulkActions.map(function (e) { return ({
                        label: e.label,
                        value: e.label,
                        disabled: e.disabled || false,
                    }); }), true) }))) : null,
            React.createElement("div", { className: "Grid-cell u-sizeFill u-md-size1of4" }, customSearchFilter || includeBasicSearch
                ? customSearchFilter || (React.createElement(BasicSearch_1.default, { searchPlaceholder: searchPlaceholder, searchFunction: updateSearchFilter }))
                : null),
            shouldPaginateAtTop && paginationItems,
            filters.length > 0 && (React.createElement("div", null,
                React.createElement(Button_1.Button, { isActive: filterLength > 0 || filterOpen, onClick: function () {
                        setFilterOpen(!filterOpen);
                    }, mods: "Button Button--primary u-spaceLeftSm", icon: "wrench" },
                    "Filter",
                    ' ',
                    filterLength > 0 ? (React.createElement("span", { className: "u-bgPrimary7 u-colorNeutral1 u-fontSizeXs", style: { borderRadius: '50px', padding: '1px 4px' } }, filterLength)) : null))),
            onExport && (React.createElement("div", null,
                React.createElement(Button_1.Button, { isActive: dataSet.length > 0, onClick: function () {
                        onExport({
                            exportToCsv: export_1.exportToCsv,
                            page: currentPage,
                            itemsPerPage: itemsPerPage,
                            sortBy: sortName,
                            sortAsc: sortAscending,
                            filter: includeBasicSearch || activeFilters ? __assign({ searchTerm: searchTerm }, activeFilters) : null,
                        });
                    }, mods: "u-spaceLeftSm", icon: "import" }, "Export")))),
        React.createElement(Panel_1.Panel, { mods: (filterOpen ? '' : 'u-hidden') + " u-padSm u-spaceTopSm u-borderNeutral4 u-bgNeutral1 Grid-cell u-flex" }, filtersSection),
        React.createElement("div", { className: "Grid-cell u-spaceTopSm" },
            React.createElement(Table_1.default, { columns: cols, rows: rows, defaultSort: defaultSortStr, externalSortingFunction: function (name, ascending) {
                    setSortName(name);
                    setSortAscending(ascending);
                }, isLoading: isLoading || isFetchingData, placeHolder: noResultsText })),
        shouldDisplayPaginationAtBottom && paginationItems)); };
    return (React.createElement("div", { className: "Grid" }, useExternalFilterProvider
        ? render()
        : (React.createElement(filterContext_1.default.Provider, { value: { activeFilters: activeFilters, setActiveFilters: setActiveFilters } }, render()))));
};
PaginatedTable.SelectFilter = SelectFilter;
PaginatedTable.DateFilter = DateFilter;
PaginatedTable.propTypes = propTypes;
exports.default = PaginatedTable;
